import { type RouteRecordRaw } from 'vue-router'

export const launchRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/LaunchDashboardView.vue'),
    meta: {
      roles: ['pb:super'],
      title: 'launch.dashboard',
    },
    name: 'brand.launch',
    path: 'launch',
  },
]
